export const hasLength = (...list: any[]) => list.some(x => x && x.length);
